import React, { ComponentProps, ReactNode } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { Box, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';


type ListItemLinkProps = {
    icon?: React.ReactElement;
    primary: ReactNode;
    to: string;
    endAddon?: ReactNode,
    endAddonMargin?: string,
    secondary?: ReactNode,
} & ComponentProps<typeof ListItemButton>;

export const ListItemLink = ({ icon, primary, to, selected, endAddon, endAddonMargin = '-5px 0 -10px', secondary = null, ...props }: ListItemLinkProps) => {
    const renderLink = React.useMemo(
        () =>
            React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>(function Link(
                itemProps,
                ref,
            ) {
                return <RouterLink to={to} ref={ref} {...itemProps} role={undefined}/>;
            }),
        [to],
    );

    return (
        <li>
            <ListItemButton component={renderLink} selected={selected} sx={props.sx}>
                {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
                <ListItemText
                    primary={primary}
                    secondary={secondary}
                />
                {!!endAddon && <Box sx={{textAlign: 'right', margin: endAddonMargin}}>{endAddon}</Box>}
            </ListItemButton>
        </li>
    )
};
